import React, { FC } from 'react';
import { ModalRouteProps } from 'context/ModalRouter';
import Modal from 'components/shared/Modal';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@kontentino/ui';
import { parseQueryParamToNumbers } from 'utils/url';
import { RespondToApprovalRequest } from 'app/modules/posts/modules/respontToApprovalRequest/RespondToApprovalRequest';

type Props = ModalRouteProps;

const RespondToApprovalModal: FC<Props> = ({ modalManager }) => {
  const { t } = useTranslation();

  const queryParameters = modalManager.getQueryParameters(['posts', 'status']);

  const [postId] = parseQueryParamToNumbers(queryParameters.posts);
  const status = Number(queryParameters.status);

  return (
    <Modal
      size="sm"
      modalManager={modalManager}
      isContentHeightAutoResizable={false}
    >
      <Modal.Header title={t('respondToApprovalRequest')} />
      {Number.isFinite(postId) && Number.isFinite(status) ? (
        <Modal.Content>
          <RespondToApprovalRequest
            postId={postId}
            status={status}
            onSettled={modalManager.close}
          />
        </Modal.Content>
      ) : (
        <>
          <Modal.Content>
            <Alert variant="warning">{t('somethingWentWrong')}</Alert>
          </Modal.Content>
          <Modal.Footer>
            <Button variant="secondary" onClick={modalManager.close}>
              {t('close')}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default RespondToApprovalModal;
